import React, { useEffect, useState } from 'react';
import './LoginQrCodeScreen.css';
import { useLocation, useNavigate } from 'react-router-dom';
import loginBackground from './loginBackground.svg';
import { getPresentationSession } from '../../services/vidcredentials';

export default function LoginQrCodeScreen() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isPollingEnabled] = useState(false);
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [pollingDataResponse, setPollingDataResponse] = useState('');

  useEffect(() => {
    let intervalId: NodeJS.Timer;
    const fetchData = async () => {
      const response = await getPresentationSession();
      if (response.error) {
        clearInterval(intervalId);
        const retryLocation = '';
        navigate('/validation-process/failure', { state: { retryLocation } });
      }
      if (response.data) {
        setPollingDataResponse(response);
        setAuthenticated(true);
        clearInterval(intervalId);
      }
    };
    fetchData()
      .then();
    intervalId = setInterval(fetchData, 5000);
    return () => clearInterval(intervalId);
  }, [isPollingEnabled, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/validation-process/success', { state: { pollingDataResponse } });
    }
  }, [pollingDataResponse, isAuthenticated, navigate]);

  const qrBase64 = location.state?.qrBase64;
  return (
    <div className="login-screen">
      <img
        src="/genericBackground.svg"
        alt="genericBackground"
        style={{
          position: 'absolute', top: 0, left: 0, objectFit: 'cover', width: '100vw', height: '100vh', zIndex: -1,
        }}
      />
      {/* Left Panel */}
      <div className="left-panel">
        {/* Top */}
        <div className="left-panel-top">
          <img src="/logo.svg" alt="DigitalGov Logo" className="logo" />
        </div>

        {/* Bottom */}
        <div className="left-panel-bottom">
          <button type="button" className="back-button" onClick={() => navigate('/login')}>
            <img src="/goBack.svg" alt="Back Logo" />
            Back
          </button>
        </div>

        {/* Center */}
        <div className="left-panel-center">
          <div className="login-heading-content-qr">
            <img src="/verticalSeparator.svg" alt="verticalSeparator" className="separator-img" />
            <h2 className="heading">
              Open your Wallet
              <br />
              and scan QR code
            </h2>
          </div>
          <p className="subtext">
            Access is protected, present a
            <br />
            verifiable credential to confirm your identity.
          </p>
        </div>

      </div>

      <div className="right-panel" style={{ backgroundImage: `url(${loginBackground})` }}>
        <div className="overlay-card">
          <div className="qr-box">
            <img src={qrBase64} alt="QR Code" className="qr-code" />
          </div>
        </div>
      </div>
    </div>
  );
}
